import React, { RefObject } from "react";

interface ContextProps {
    myRef: RefObject<any> | null;
}

const Context = React.createContext<ContextProps>({ myRef: null });

export default Context;
